import { ChangeDetectionStrategy, Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'app/services/app.service';
import { ConfirmDialogComponent, IConfirmDialogData } from 'app/main/dialogs/confirm-dialog/dialog.component';
import { AssistantService } from '../assistant.service';
import { AssistantContextService } from '../assistant-context.service';

/**
 * Avviso nelle UI manuali dei prezzi quando il pacchetto è gestito dall'assistente: spiega perché
 * aggiunta/modifica/eliminazione non ci sono e offre le due strade (assistente o ritorno alla gestione manuale).
 */
@Component({
	selector: 'assistant-managed-banner',
	templateUrl: './assistant-managed-banner.component.html',
	styleUrls: ['./assistant-managed-banner.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AssistantManagedBannerComponent{

	releasing = false;

	constructor(
		public assistant: AssistantService,
		private contextService: AssistantContextService,
		private dialog: MatDialog,
		private appService: AppService
	){}

	/**
	 * Dal "Listino prezzi" (dialog): il dialog è un popover nativo nel top layer e coprirebbe il pannello,
	 * quindi si chiude prima e il pannello si apre accanto alla pagina (la lista si ricarica alla chiusura).
	 */
	openAssistant(): void{
		if(this.dialog.openDialogs.length) this.dialog.closeAll();
		this.assistant.open.next(true);
	}

	async releaseToManual(): Promise<void>{
		const entity = this.contextService.entity.value;
		if(!entity || this.releasing) return;

		const confirmed = await firstValueFrom(this.dialog.open<ConfirmDialogComponent, IConfirmDialogData>(ConfirmDialogComponent, {
			width: '520px',
			data: {
				title: 'Tornare alla gestione manuale?',
				contentMessage: "I prezzi resteranno quelli attuali e tornerai a modificarli dalle schermate del pacchetto. Se poi li modifichi di nuovo con l'assistente, la gestione manuale verrà bloccata di nuovo.",
				positiveText: 'Torna alla gestione manuale',
				negativeText: 'Annulla'
			}
		}).afterClosed());
		if(!confirmed) return;

		this.releasing = true;
		this.assistant.releasePricing(entity).subscribe({
			next: response => {
				this.releasing = false;
				this.appService.showSuccessMessage(response.message);
			},
			error: error => {
				this.releasing = false;
				this.appService.showErrorMessage(AssistantService.toError(error).message);
			}
		});
	}
}
